import $ from 'jquery';

$(function () {
    if ($('#ctaModal').length !== 0) {
        document.querySelector('#ctaModal').addEventListener('show.bs.modal', () => {
            $('body').addClass('backdrop-dark');
        });
        document.querySelector('#ctaModal').addEventListener('hidden.bs.modal', () => {
            $('body').removeClass('backdrop-dark');
        });
    }
});
